module.exports = __webpack_public_path__ + "static/media/img-05.49d392c9.jpg";